module.exports = __webpack_public_path__ + "static/media/hotpads-logo.11bb77c8.svg";